import { useEffect, useState } from 'react';
import { useEventPlateId } from '@udecode/plate-core';
import Popup from '../Popup';
import { useTPlateEditorRef } from '../../plate';
import { Connect } from './Connect';
import { SelectTemplate } from './SelectTemplate';
import { MapFields } from './MapFields';

export const CMS_CONNECT_STEPS = {
  connect: 'connect',
  template: 'template',
  fields: 'fields',
};

export function CMSConnectPopup() {
  const [open, setopen] = useState(false);

  const editorID = useEventPlateId();
  const editor = useTPlateEditorRef(editorID as string);

  const [step, setstep] = useState(CMS_CONNECT_STEPS.connect);

  useEffect(() => {
    if (!editor?.emitter)
      return () => {
        /* do nothing */
      };
    const handler = (openStep: keyof typeof CMS_CONNECT_STEPS) => {
      setopen((v) => !v);
      setstep(openStep);
    };
    editor?.emitter?.on('popup:toggle-cms-connect', handler);
    return () => editor?.emitter?.off('popup:toggle-cms-connect', handler);
  }, [editor]);

  const reset = () => {
    setstep(CMS_CONNECT_STEPS.connect);
  };

  const onClose = () => {
    setopen(false);
    reset();
  };

  return (
    <Popup
      open={open}
      setopen={setopen}
      width={800}
      height={600}
      className="p-12 flex flex-col items-center justify-start gap-6"
    >
      {step === 'connect' && <Connect goNext={() => setstep(CMS_CONNECT_STEPS.template)} />}
      {step === 'template' && (
        <SelectTemplate
          goBack={() => setstep(CMS_CONNECT_STEPS.connect)}
          goNext={() => setstep(CMS_CONNECT_STEPS.fields)}
        />
      )}
      {step === 'fields' && (
        <MapFields
          goBack={() => setstep(CMS_CONNECT_STEPS.template)}
          onClose={onClose}
          onBackToConnect={() => setstep(CMS_CONNECT_STEPS.connect)}
        />
      )}
    </Popup>
  );
}
